import type { IJsonModel } from 'flexlayout-react';

export const mainModelJson: IJsonModel = {
    global: {
        tabEnableClose: false,
        tabSetEnableSingleTabStretch: true,
        tabSetEnableDeleteWhenEmpty: true,
        tabSetEnableDrop: false,
        tabEnableRename: false,
        tabSetEnableMaximize: false,
        tabEnableDrag: false
    },

    layout: {
        type: 'row',
        weight: 100,
        children: [
            {
                type: 'tabset',
                weight: 70,
                id: 'content-tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Wall Forming',
                        component: 'wallForming'
                    }
                ]
            },
            {
                type: 'tabset',
                weight: 30,
                id: 'setting-tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Automated Placement',
                        component: 'settings',
                        id: 'setting-tab'
                    }
                ]
            }
        ]
    }
};
